/*
 *
 * @see clientAddressBook.js
 * @see checkout
 *
 */
Core.DVAInformation = {
    init: function(data) {
        function isSet(data, name) {
            return data && typeof data[name] !== 'undefined';
        }

        Core.DVAInformation.Cache = {
            root: isSet(data, "root") ? document.querySelector(data.root) : document,
            datepickerInput: isSet(data, "datepickerInput") ? data.datepickerInput : ".form-date input",
            domActivites: isSet(data, "domActivites") ? data.domActivites : "#DVAActivities",
            domBehaviour: isSet(data, "domBehaviour") ? data.domBehaviour : "#DVABehaviour",
            domComplexHealthCare: isSet(data, "domComplexHealthCare") ? data.domComplexHealthCare : "#DVAComplex",
            domFundingOtherType: isSet(data, "domFundingOtherType") ? data.domFundingOtherType : "#DVAFundingOtherType",
            domFundingOtherNotes: isSet(data, "domFundingOtherNotes") ? data.domFundingOtherNotes : "#DVAFundingOtherNotes",
        };

        Core.DVAInformation.initPicker();
        // Core.DVAInformation.addEventListenerRCF();
        Core.DVAInformation.addEventListenerFundingOther();
        Core.DVAInformation.initACFIClassification();
    },

    initPicker: function() {
        function isDatePicker2() {
            var elem = document.querySelector(Core.DVAInformation.Cache.datepickerInput);
            return elem && elem.dataset && elem.dataset.datepicker2 === '';
        }

        isDatePicker2()
            ? Core.DVAInformation.initDatePicker2()
            : Core.DVAInformation.initKendoDatePicker();
    },

    initKendoDatePicker: function() {
        var rootDom = Core.DVAInformation.Cache.root;
        var $el = $(rootDom.querySelectorAll(Core.DVAInformation.Cache.datepickerInput));

        if (! $el || $el.length === 0) {
            return;
        }

        $el.kendoDatePicker({
            format: "dd/MM/yyyy",
            start: Core.PortalCheckout.todayDate(),
            footer: '<span></span>',
            change: function (e) {
                $(this.element).removeClass('error');
                $(this.element).trigger('blur');
            }
        });

        //make the input readonly
        $el.prop('readonly', true);

        $el.on('click', function () {
            $(this).data('kendoDatePicker').open();
        });

        $el.parent().find('[role="button"]').on('click', function () {
            var input = $(this).parent().find('input');

            if (!input.prop('disabled')) {
                setTimeout(function() {
                    $(this).parent().find('input').data('kendoDatePicker').open();
                }, 100);
            }
        });

        $el.on('blur', function (e) {
            Core.PortalCheckout.calendarOnBlur($(this));
        });
    },

    initDatePicker2: function() {
        var rootDom = Core.DVAInformation.Cache.root;

        Array
            .from(rootDom.querySelectorAll(Core.DVAInformation.Cache.datepickerInput))
            .forEach(function(itm) {
                Core.DatePicker2(itm).init()
            });
    },

    /*
    addEventListenerRCF: function() {
        var rootDom = Core.DVAInformation.Cache.root;
        var radios = rootDom.querySelectorAll('[name="DVAResidentialCareFacility"], [name="ResidentialCareFacility"]');
        var optionsContainer = rootDom.querySelector('.rcf-options');

        function resetSelect() {
            var $domActivites = $(Core.DVAInformation.Cache.domActivites);
            var $domBehaviour = $(Core.DVAInformation.Cache.domBehaviour);
            var $domComplexHealthCare = $(Core.DVAInformation.Cache.domComplexHealthCare);
            var list = [$domActivites, $domBehaviour, $domComplexHealthCare];

            if (!$domActivites || !$domBehaviour || !$domComplexHealthCare) {
                return;
            }

            list.forEach(function(item) {

                var $kItem = item.data("kendoDropDownList");
                $kItem
                    && ( $kItem.value('')
                        , $kItem.trigger('change') );
            });
        }

        function onChange(e) {
            var target = e.currentTarget;
            if ($(target).prop('readonly')) {
                e.preventDefault();
                return;
            }

            var currentValue = target.value.toLowerCase();
            var isVisible = (currentValue === 'yes' || currentValue === 'true');

            isVisible
                ? optionsContainer.classList.remove('d-none')
                : optionsContainer.classList.add('d-none');

            ! isVisible
                && resetSelect();

            // check if in viewport, if not scroll to view
            if (isVisible) {
              var $closestRow = $(target).closest('.row');
              if ($closestRow && $closestRow.length > 0) {
                $closestRow.get(0).scrollIntoView();
              }
            }
        }

        function addListeners(elem) {
            elem.addEventListener('change', onChange);
        }

        Array.from(radios).forEach(addListeners);
    },
    */

    addEventListenerFundingOther: function() {
        var rootDom = Core.DVAInformation.Cache.root;
        var radios = rootDom.querySelectorAll('[name="DVAFundingOther"], [name="FundingOther"]');
        var optionsContainer = rootDom.querySelector('.fundingother-options');

        function resetSelect() {
            var $domFundingOtherType = $(Core.DVAInformation.Cache.domFundingOtherType);
            var list = [$domFundingOtherType];

            if (!$domFundingOtherType) {
                return;
            }

            list.forEach(function(item) {
                var $kItem = item.data("kendoDropDownList");
                $kItem.value('');
                $kItem.trigger('change');
            });
        }

        function resetNotes() {
            var $domFundingOtherNotes = $(Core.DVAInformation.Cache.domFundingOtherNotes);
            $domFundingOtherNotes &&
                $domFundingOtherNotes.val('');
        }

        function onChange(e) {
            var target = e.currentTarget;
            if ($(target).prop('readonly')) {
                e.preventDefault();
                return;
            }

            var currentValue = target.value.toLowerCase();
            var isVisible = (currentValue === 'yes' || currentValue === 'true');

            isVisible
                ? optionsContainer.classList.remove('d-none')
                : optionsContainer.classList.add('d-none');

            ! isVisible
                && ( resetSelect()
                   , resetNotes());

             // check if in viewport, if not scroll to view
            if (isVisible) {
              var $closestRow = $(target).closest('.row');
              if ($closestRow && $closestRow.length > 0) {
                $closestRow.get(0).scrollIntoView();
              }
            }
        }

        function addListeners(elem) {
            elem.addEventListener('change', onChange);
        }

        Array.from(radios).forEach(addListeners);
    },

    initACFIClassification: function() {
        var rootDom = Core.DVAInformation.Cache.root;
        var $domActivites = $(Core.DVAInformation.Cache.domActivites);
        var $domBehaviour = $(Core.DVAInformation.Cache.domBehaviour);
        var $domComplexHealthCare = $(Core.DVAInformation.Cache.domComplexHealthCare);
        var domACFI = rootDom.querySelector('#acfi');
        var domACFIShow = rootDom.querySelector('.acfi-show');

        function executeCallback(clb) {
            clb();
        };

        if (!$domActivites || !$domBehaviour || !$domComplexHealthCare || !domACFI || !domACFIShow) {
            return;
        }


        var d = {
            _activities: '',
            _behaviour: '',
            _complexHealthCare: '',

            subscriberList: {
                activities: [],
                behaviour: [],
                complexHealthCare: [],
            },

            set activities(activities) {
                this._activities = activities;

                d.subscriberList.activities.forEach(executeCallback);
            },

            set behaviour(behaviour) {
                this._behaviour = behaviour;

                d.subscriberList.behaviour.forEach(executeCallback);
            },

            set complexHealthCare(complexHealthCare) {
                this._complexHealthCare = complexHealthCare;

                d.subscriberList.complexHealthCare.forEach(executeCallback);
            },

            get acfi() {
                var acfi = this._activities + this._behaviour + this._complexHealthCare;

                return acfi.length === 3 ? acfi : '';
            },

            subscribe(name, callback) {
                d.subscriberList[name].push(callback);
            }
        };


        function loadValues() {
            d.activities = $domActivites.val();
            d.behaviour = $domBehaviour.val();
            d.complexHealthCare = $domComplexHealthCare.val();
        }

        function updateACFI() {
            domACFI.value = d.acfi;
            domACFIShow.innerText = d.acfi;
        }


        loadValues();

        d.subscribe('activities', updateACFI);
        d.subscribe('behaviour', updateACFI);
        d.subscribe('complexHealthCare', updateACFI);

        $domActivites.data("kendoDropDownList") &&
            $domActivites.data("kendoDropDownList").bind("change", function() {
                d.activities = $domActivites.data("kendoDropDownList").value();
            });

        $domBehaviour.data("kendoDropDownList") &&
            $domBehaviour.data("kendoDropDownList").bind("change", function() {
                d.behaviour = $domBehaviour.data("kendoDropDownList").value();
            });

        $domComplexHealthCare.data("kendoDropDownList") &&
            $domComplexHealthCare.data("kendoDropDownList").bind("change", function() {
                d.complexHealthCare = $domComplexHealthCare.data("kendoDropDownList").value();
            });
    },

    /*

        data

        Core.DVAInformation.isValid({
            dvaCardType: "#DVACardType",
            dvaDOB: "#DVADOB",
            dvaRCF: "#yes_rcf",
            dvaADL: "#DVAActivities",
            dvaBEH: "#DVABehaviour",
            dvaCHC: "#DVAComplex",
            dvaFundingOther: #FundingOther,
            dvaFundingOtherType: #FundingOtherType,
        });


     */
    isValid: function(data) {
        if (data === null) {
            true;
        }

        var isValid = true;
        var errorList = [];

        function checkIsValid(selectValidator) {
            isValid = selectValidator.isValid() && isValid;

            if (!selectValidator.isValid()) {
                selectValidator.elemSelector && errorList.push(selectValidator.elemSelector);
            }
        }

        function isDatePicker2() {
            var elem = document.querySelector(data.dvaDOB);
            return elem && elem.dataset && elem.dataset.datepicker2 === '';
        }

        var dvaCardType = SelectValidator(data.dvaCardType);
        var dvaDOB = isDatePicker2() ? DatePicker2Validator(data.dvaDOB) : DateInputValidator(data.dvaDOB);
        var dvaRCF = document.querySelector(data.dvaRCF);

        var dvaFundingOtherType = SelectValidator(data.dvaFundingOtherType);
        var dvaFundingOther = document.querySelector(data.dvaFundingOther);

        // var dvaADL = SelectValidator(data.dvaADL);
        // var dvaBEH = SelectValidator(data.dvaBEH);
        // var dvaCHC = SelectValidator(data.dvaCHC);

        if (!dvaCardType || !dvaDOB || !dvaRCF) { // || !dvaADL || !dvaBEH || !dvaCHC
            // in case no items it's valid
            return true;
        }

        [dvaCardType, dvaDOB].forEach(checkIsValid);

        // if (dvaRCF.checked) {
        //     [dvaADL, dvaBEH, dvaCHC].forEach(checkIsValid);
        // }

        if (dvaFundingOther && dvaFundingOther.checked) {
            [dvaFundingOtherType].forEach(checkIsValid);
        }

        // check position between custom error (card type and funding other type dropdown) and form fields
        var top = 0;
        if (errorList.length > 0) {
            errorList.forEach(function(item, i) {
                var offsetTop = item && $(item).closest('.k-dropdownlist').offset().top;
                if (i === 0 || offsetTop > top) {
                    top = offsetTop;
                }
            });
        }

        // check first error
        var $form = $(data.dvaCardType).closest('form');
        if ($form && $form.length > 0) {
            var firstError = $form.find('.error:visible').first();
            if (firstError && firstError.length > 0) {
                var errorTop = firstError.offset().top;

                // compare which top is lower
                if (top === 0 || errorTop < top) {
                    top = errorTop;
                }
            }
        }

        // check if within modal or not
        // if ($form.closest('.k-window-content').length > 0) {
        //     $form.find('div[class*=__content]').animate({
        //         scrollTop: top
        //     }, 300);
        // } else {
        // }
        
        top && Core.ScrollToView(top - 30);
        return isValid;
    },

    isValidDischarged: function(data) {
        if (data === null) {
            true;
        }

        var isValid = true;

        function checkIsValid(selectValidator) {
            isValid = selectValidator.isValid() && isValid;
        }

        var dvaDOD = DateInputValidator(data.dvaDOD);
        var dvaHospitalDischarge = document.querySelector(data.dvaHospitalDischarge);

        if (!dvaDOD || !dvaHospitalDischarge) {
            // in case no items it's valid
            return true;
        }

        if (dvaHospitalDischarge.checked) {
            [dvaDOD].forEach(checkIsValid);
        }

        return isValid;
    }
};
